// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17bMb","question":"styles_question__3kCd2","inputVisibleButton":"styles_inputVisibleButton__1JKg-","note":"styles_note__3Nlp8"};